// {{BASE_URL}}/api/schemeType
import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';
import { isUndefined } from 'lodash';

export interface IDataItems {
  vat_return_reminder_id: number;
  applicant_id: number;
  vat_number: string;
  quarter_id: number;
  quarter: string;
  year: number;
  reminded_date: Date;
  is_sent: boolean;
}

export interface IPaging {
  page: number;
  pageSize: number;
  total: number;
}

export interface IVatReturnRemindersListOutput {
  items: IDataItems[];
  paging: IPaging;
}

export interface IVatReturnRemindersListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vatNumber?: string | null;
  year?: string | null;
  period?: string | null;
  remindedDateFrom?: string | null;
  remindedDateTo?: string | null;
}

export const fetchVatReturnRemindersList = async (
  payload: IVatReturnRemindersListInput
): Promise<Types.ResponseOutput> => {
  const queryParams = new URLSearchParams({
    page: payload.page.toString(),
    pageSize: payload.pageSize.toString(),
    sortField: payload.sortField,
    order: payload.order,
  });
  if (payload.vatNumber) queryParams.set('vatNumber', payload.vatNumber);
  if (payload.year) queryParams.set('year', payload.year);
  if (payload.period) queryParams.set('period', payload.period);
  if (payload.remindedDateFrom)
    queryParams.set('remindedDateFrom', payload.remindedDateFrom);
  if (payload.remindedDateTo)
    queryParams.set('remindedDateTo', payload.remindedDateTo);
  const { data }: any = await request(
    'get',
    `${
      Environment.API_BASE_URL
    }/api/vatreturn-reminders/list?${queryParams.toString()}`
  );

  let _data: IVatReturnRemindersListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

export interface IVatReturnRemindersToGenerateInput {
  byQuarter: boolean | undefined;
}

export const vatReturnRemindersToGenerate = async (
  payload: IVatReturnRemindersToGenerateInput
): Promise<Types.ResponseOutput> => {
  const queryParameter = isUndefined(payload.byQuarter)
    ? ''
    : `?byQuarter=${payload.byQuarter}`;
  const { data }: any = await request(
    'post',
    `${Environment.API_BASE_URL}/api/vatreturn-reminders/generate${queryParameter}`
  );

  let output: Types.ResponseOutput = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};
